// --- START OF FILE src/components/Sidebar.jsx ---

import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../styles/Sidebar.css';

const Sidebar = ({ dashboards, isOpen, toggleSidebar }) => {
  const { t } = useTranslation();

  return (
    <aside className={`sidebar-container flex flex-col ${isOpen ? 'open' : ''}`}>
      <div className="sidebar-logo-container">
        <img
          src="/Reseye Logo.png"
          alt={t('logoAltText')}
          className="sidebar-logo-image"
        />
      </div>

      <nav className="flex flex-col flex-1 justify-between">
        <div className="sidebar-menu-scrollable-content">
          <div className="sidebar-section">
            <h3 className="sidebar-title">{t('sidebarDashboardsTitle')}</h3>
            <ul className="sidebar-list">

              {(dashboards || []).map(d => (
                <li key={d.id}>
                  <NavLink
                    to={`/dashboard/${d.id}`}
                    className={({ isActive }) =>
                      `sidebar-link-text ${isActive ? 'active' : ''}`
                    }
                    onClick={isOpen ? toggleSidebar : undefined}
                  >
                    {d.name || d.id}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>

          <div className="sidebar-section sidebar-separator-top">
            <ul className="sidebar-list">
              <li>
                <NavLink
                  to="/about"
                  className={({ isActive }) =>
                    `sidebar-link-text ${isActive ? 'active' : ''}`
                  }
                  onClick={isOpen ? toggleSidebar : undefined}
                >
                  {t('sidebarAboutUsLink')}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/contact"
                  className={({ isActive }) =>
                    `sidebar-link-text ${isActive ? 'active' : ''}`
                  }
                  onClick={isOpen ? toggleSidebar : undefined}
                >
                  {t('sidebarContactUsLink')}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/settings"
                  className={({ isActive }) =>
                    `sidebar-link-text ${isActive ? 'active' : ''}`
                  }
                  onClick={isOpen ? toggleSidebar : undefined}
                >
                  {t('sidebarSettingsLink')}
                </NavLink>
              </li>
            </ul>
          </div>
        </div>

        <div className="sidebar-copyright-absolute">
          <p className="sidebar-copyright-text">
            {t('sidebarCopyrightText')}
          </p>
        </div>
      </nav>
    </aside>
  );
};

export default Sidebar;
// v1.0.0
// --- END OF FILE src/components/Sidebar.jsx ---